import {flow, Instance, types} from 'mobx-state-tree';
import {ResetModel} from 'core/models';

import {TreeCatalog} from './models';

const TPCatalogs = types
  .compose(
    ResetModel,
    types.model('TPCatalogs', {
      projectUuid: '',
      checkpointUuid: '',
      treeCatalog: types.optional(TreeCatalog, {})
    })
  )
  .actions((self) => ({
    loadTreeCatalog: flow(function* () {
      yield self.treeCatalog.load(self.projectUuid, self.checkpointUuid);
    })
  }))
  .actions((self) => ({
    reload: flow(function* () {
      yield Promise.allSettled([self.loadTreeCatalog()]);
    })
  }))
  .actions((self) => ({
    init: flow(function* (projectUuid: string, checkpointUuid: string) {
      self.projectUuid = projectUuid;
      self.checkpointUuid = checkpointUuid;
      yield self.reload();
    })
  }));

export type TTPCatalogsModel = Instance<typeof TPCatalogs>;

export {TPCatalogs};
